// extracted by mini-css-extract-plugin
export default {"input-error":"styles_input-error__OyzQT"};